module.exports = __webpack_public_path__ + "img/production-meter.700c15db.svg";